// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
/**
 * WgptService provides an API to Chat GPT
 */
export const VoicemailTranscriptionService = {
    GetVoicemailTranscription(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/transcription/voicemail/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
};
